import { type Props as TagProps } from "../components/Tag";
import { Address } from "./address";

export interface IPayment {
  amount: number;
  billingAddress: Address;
  charge: number;
  method: PaymentTypeEnum;
  status: PaymentStatusEnum;
  card?: ICreditCard;
}

export interface ICreditCard {
  brand: CreditCardBrandEnum;
  lastDigits: string;
  installments: number;
  installmentValue: number;
}

export enum CreditCardBrandEnum {
  HIPERCARD = "Hipercard",
  ELO = "Elo",
  AMERICAN_EXPRESS = "American Express",
  DINERS = "Diners",
  MASTERCARD = "Mastercard",
  VISA = "Visa",
}

export enum PaymentTypeEnum {
  PIX = "PIX",
  BILLET = "BILLET",
  CREDIT_CARD = "CREDIT_CARD",
}

export enum PaymentStatusEnum {
  PENDENTE = 1,
  PROCESSANDO = 2,
  AUTORIZADO = 3,
  DISPUTANDO = 5,
  ESTORNADO = 6,
  BAIXADO = 7,
  RECUSADO = 8,
  LIBERADO = 11,
  EM_CANCELAMENTO = 12,
  CHARGE_BACK = 13,
  PRE_AUTORIZADO = 14,
  DEVOLUCAO_CONTESTACAO = 15,
  ABORTADO = 18,
  EM_DEVOLUCAO = 19,
}

export type PaymentStatusValue = PaymentStatusEnum | keyof typeof PaymentStatusEnum;

export const paymentStatusName = {
  [PaymentStatusEnum.PENDENTE]: "Pendente",
  [PaymentStatusEnum.PROCESSANDO]: "Processando",
  [PaymentStatusEnum.AUTORIZADO]: "Pago",
  [PaymentStatusEnum.DISPUTANDO]: "Disputando",
  [PaymentStatusEnum.ESTORNADO]: "Estornado",
  [PaymentStatusEnum.BAIXADO]: "Baixado",
  [PaymentStatusEnum.RECUSADO]: "Recusado",
  [PaymentStatusEnum.LIBERADO]: "Liberado",
  [PaymentStatusEnum.EM_CANCELAMENTO]: "Em cancelamento",
  [PaymentStatusEnum.CHARGE_BACK]: "Chargeback",
  [PaymentStatusEnum.PRE_AUTORIZADO]: "Pré autorizado",
  [PaymentStatusEnum.DEVOLUCAO_CONTESTACAO]: "Devolução de contestação",
  [PaymentStatusEnum.ABORTADO]: "Abortado",
  [PaymentStatusEnum.EM_DEVOLUCAO]: "Em devolução",
};

export const getPaymentStatusName = (status: PaymentStatusValue | null | undefined): string => {
  if (status === null || status === undefined) {
    return "Indisponível";
  }

  const numericStatus =
    typeof status === "string" && status in PaymentStatusEnum
      ? PaymentStatusEnum[status as keyof typeof PaymentStatusEnum]
      : typeof status === "string"
        ? Number(status)
        : status;
  return paymentStatusName[numericStatus as unknown as keyof typeof paymentStatusName] ?? "Indisponível";
};

export const getPaymentStatusTagColor = (status: PaymentStatusValue | null | undefined): TagProps["color"] => {
  const numericStatus =
    typeof status === "string" && status in PaymentStatusEnum
      ? PaymentStatusEnum[status as keyof typeof PaymentStatusEnum]
      : typeof status === "string"
        ? Number(status)
        : status;

  if (numericStatus === PaymentStatusEnum.AUTORIZADO || numericStatus === PaymentStatusEnum.LIBERADO) {
    return "feedback-success";
  }

  if ([PaymentStatusEnum.ESTORNADO, PaymentStatusEnum.RECUSADO].includes(numericStatus as PaymentStatusEnum)) {
    return "feedback-error";
  }

  return "feedback-warning";
};
